import {Cohort} from "./cohort";

export class TrialProfile {
  cohorts: Cohort[] = [];

  constructor() {
  }
}
